import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';

import { toAbsoluteUrl } from '../../../_metronic';
import '../../../_metronic/_assets/sass/pages/login/login-1.scss';
import TermDialog from '../../components/other/Dialog/TermDialog';
import { AuthTabs } from './components';
import { IAppState } from '../../store/rootDuck';
import ChangePasswordPage from './ChangePasswordPage';
import { ReactComponent as Logo } from "../../../_metronic/layout/assets/layout-svg-icons/logo.svg";

export const AuthPage: React.FC = () => {
  const intl = useIntl();
  const history = useHistory();

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContentType, setDialogContentType] = useState('');

  const handleDialogOpen = useCallback(
    contentType => {
      setDialogContentType(contentType);
      setOpenDialog(true);
    },
    [setDialogContentType, setOpenDialog]
  );

  const store = useSelector((store: IAppState) => store, shallowEqual);

  // check if user is authorized
  useEffect(() => {
    if (store.auth.user) {
      history.push('/');
    }
  }, [store.auth.user]);

  return (
    <div
      className='kt-grid kt-grid--ver kt-grid--root'
      style={{
        minHeight: '100vh',
        maxHeight: '100vh',
        overflowY: 'auto',
      }}
    >
      <div id='kt_login' className='kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1'>
        <div className='kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile'>
          <div
            className='kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside'
            style={{
              backgroundImage: `url(${toAbsoluteUrl('/media/bg/bg-4.jpg')})`,
            }}
          >
            <div className='kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver'>
              <div className='kt-grid__item kt-grid__item--middle'>
                {/* <h3 className='kt-login__title'> */}
                {/*  {intl.formatMessage({ id: 'AUTH.WELCOME.TITLE' })} */}
                {/* </h3> */}
                <Logo />
                {/* <h4 className='kt-login__subtitle'> */}
                {/*  {intl.formatMessage({ id: 'AUTH.WELCOME.SUBTITLE' })} */}
                {/* </h4> */}
              </div>
            </div>
            <div className='kt-grid__item'>
              <div className='kt-login__info' style={{ flexDirection: 'column', marginTop:15 }}>
                <div className='kt-login__copyright' style={{ marginBottom: 5 }}>
                  <div className='kt-login__menu'>
                    <a
                      href='https://start-mobile.net'
                      className='kt-link'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {intl.formatMessage({ id: 'AUTH.CREATOR.COMPANY' })}
                    </a>
                  </div>
                </div>
                <div className='kt-login__menu'>
                  {/* eslint-disable-next-line */}
                  <a
                    className='kt-link'
                    href='/documents/legacy/read'
                    // onClick={() => handleDialogOpen('user_agreement')}
                    style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                  >
                    <FormattedMessage id='SUBMENU.LEGAL_TERMS' />
                  </a>
                  <span
                    style={{
                      color: 'rgba(0, 0, 0, 0.7)',
                      marginRight: 4,
                      marginLeft: 4,
                    }}
                  >
                    |
                  </span>
                  {/* eslint-disable-next-line */}
                  <a
                    className='kt-link'
                    href='/documents/privacy/read'
                    // onClick={() => handleDialogOpen('privacy_policy')}
                    style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                  >
                    <FormattedMessage id='SUBMENU.LEGAL_PRIVACY' />
                  </a>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <a
                      href="/documents/shipping/read"
                      rel='noopener noreferrer'
                      className='kt-link'
                      style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                  >
                    <FormattedMessage id='SUBMENU.SHIPPING' />
                  </a>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <a
                      href="/documents/refund/read"
                      // onClick={() => this.handleDialogOpen('refund_policy')}
                      rel='noopener noreferrer'
                      className='kt-link'
                      style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                  >
                    <FormattedMessage id='SUBMENU.REFUND' />
                  </a>
                  {
                    // isAdmin &&
                    (<>
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                      <a
                          href="/documents/developers/read"
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                          style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                      >
                        {intl.formatMessage({id: 'SUBMENU.DEVELOPERS'})}
                      </a>
                    </>)
                  }
                  {
                    // isAdmin &&
                    (<>
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                      <a
                          href="/documents/furniture_manufacturers/read"
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                          style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                      >
                        {intl.formatMessage({ id: 'SUBMENU.FURNITURE' })}
                      </a>
                    </>)
                  }
                  {
                    // isAdmin &&
                    (<>
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                      <a
                          href="/documents/interior_designers/read"
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                          style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                      >
                        {intl.formatMessage({ id: 'SUBMENU.DESIGNER.INT' })}
                      </a>
                    </>)
                  }
                  {
                    // isAdmin &&
                    (<>
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                      <a
                          href="/documents/manufacturers_finishing_materials/read"
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                          style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                      >
                        {intl.formatMessage({ id: 'SUBMENU.MATERIALS' })}
                      </a>
                    </>)
                  }
                  {
                    // isAdmin &&
                    (<>
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                      <a
                          href="/documents/realtors/read"
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                          style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                      >
                        {intl.formatMessage({ id: 'SUBMENU.REALTORS' })}
                      </a>
                    </>)
                  }
                  {
                    // isAdmin &&
                    (<>
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                      <a
                          href="/documents/repair_organizations/read"
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                          style={{ marginRight: 0, whiteSpace: 'nowrap' }}
                      >
                        {intl.formatMessage({ id: 'SUBMENU.ORGANIZATIONS' })}
                      </a>
                    </>)
                  }
                </div>
              </div>
            </div>
          </div>
          <div className='kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper'>
            <div className='kt-login__head'>
              {/* <div className={classes.languageBlock}>
                <Topbar />
              </div> */}
            </div>

            <Switch>
              <Route path='/auth/main' component={AuthTabs} />
              <Route path='/auth/change_password/:code' component={ChangePasswordPage} />
              <Redirect from='/auth' exact to='/auth/main' />
              <Redirect to='/auth/main' />
            </Switch>
          </div>
        </div>
      </div>
      <TermDialog
        isOpen={openDialog}
        handleClose={() => setOpenDialog(false)}
        contentType={dialogContentType}
      />
    </div>
  );
};
